var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.5H1C0.447 0.5 0 0.947 0 1.5V4.5C0 5.053 0.447 5.5 1 5.5C1.553 5.5 2 5.053 2 4.5V2.5H8V15.5H6C5.447 15.5 5 15.947 5 16.5C5 17.053 5.447 17.5 6 17.5H12C12.553 17.5 13 17.053 13 16.5C13 15.947 12.553 15.5 12 15.5H10V2.5H16V4.5C16 5.053 16.447 5.5 17 5.5C17.553 5.5 18 5.053 18 4.5V1.5C18 0.947 17.553 0.5 17 0.5Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.80c1116ff2f377804b175511cd7e28de.svg";
export { ForwardRef as ReactComponent };